import { RouteObject } from 'react-router'
import React, { lazy } from 'react'
import ProtectRouter from '../components/protect.router'

const Person = lazy(() => import('../containers/person/person'))
const PersonDescribe = lazy(() => import('../containers/person/describe/person.describe'))

const PersonRouter: RouteObject[] = [
    {
        path: '/app/person',
        element: <ProtectRouter privateRouter={true} scopes={[ 'pe:ra', 'pe:r' ]}>
            <Person/>
        </ProtectRouter>
    },
    {
        path: '/app/person/:personDocument/description',
        element: <ProtectRouter privateRouter={true} scopes={[ 'pe:ra', 'pe:r' ]}>
            <PersonDescribe/>
        </ProtectRouter>
    },
    {
        path: '/app/person/:personDocument',
        element: <ProtectRouter privateRouter={true} scopes={[ 'pe:ra', 'pe:r' ]}>
            <PersonDescribe/>
        </ProtectRouter>
    }
]

export default PersonRouter
